import { Injectable } from '@angular/core';
import { CONSTANT } from '../config/constant';
import { createMongoAbility } from '@casl/ability';

@Injectable({
  providedIn: 'root'
})
export class AbilityService {

  constructor() { }

  extractAbilities(source: Array<string>) {
    const extracted: any = [];
    source.forEach(([actions, subjects]) => {
      actions.split(',').forEach(action => {
        action && subjects.split(',').forEach(subject => {
          subject && extracted.push({ action, subject })
        })
      })
    })
    return extracted
  }

  setAbilities(ablities: Array<string>){
    sessionStorage.setItem(CONSTANT.RULES, JSON.stringify(this.extractAbilities(ablities)))
  }
  getAbilities(){
    const ablities = sessionStorage.getItem(CONSTANT.RULES)
    return ablities ? JSON.parse(ablities) : []
  }

  getAbilitiesChecker(){
    return createMongoAbility<[string, string]>(this.getAbilities())
  }

  clearAbilities(){
    sessionStorage.removeItem(CONSTANT.RULES)
  }
}
